const payloadHandler = (payload) => {
  if(Array.isArray(payload)){
    return payload?.[0];
  }
  return payload || {};
}

export const PersonalReducer = (state = [], action) => {
  const { type, payload } = action;

  switch (type) {
    case "add":
      return payloadHandler(payload).ptside === "A" ? [payloadHandler(payload), ...state] : [...state, payloadHandler(payload)];

    case "edit":
      return state.map((item) => {
        if (item.ptside == payload.ptside) {
          if (item.customize != payload.customize) {
            return {
              ...payload,
            };
          }
          return {
            ...item,
            ...payload,
          };
        }
        return item;
      });
    case "remove":
      return state.filter((item) => item.ptside !== payload.ptside);

    default:
      return state;
  }
}

export const createPrintEmoji = (text) => {
  const ele = document.createElement("span");
  ele.display = "none";
  ele.innerHTML = text;
  ele.classList.add("lenovo-emoji");
  document.body.appendChild(ele);

  setTimeout(() => {
    document.body.removeChild(ele);
  }, 10);

  return ele.innerHTML;
};
